import React from "react";
import PropTypes from "prop-types";
import Icon from "./Icon";
import AppUtils from "@src/utils/appUtils";
import { setColourShadeIfMissing } from "@signolteam/shared/colours";

const Tag = ({
  children,
  color = "primary",
  closeFunc,
  block = false,
  border = false,
  className,
  rounded = "lg",
  fullWidth = false,
  textSize = "base",
}) => {
  const bgColor = setColourShadeIfMissing(color, 400);
  return (
    <div className={`mr-2 ${fullWidth ? "w-full" : "max-w-72"}`}>
      <span
        className={`px-3 py-1 leading-6
          ${block ? "flex items-center" : "inline-flex items-center"}
          text-${textSize}
          rounded-${rounded}
          bg-${bgColor}
          ${border ? "border-2" : ""}
          ${!!closeFunc ? "shadow shadow-neutral-100 hover:shadow-neutral-200 transition-shadow" : ""}
        `}
      >
        <span className={`${block ? "block w-full" : ""} ${className || ""}`}>
          {children}
        </span>
        {!!closeFunc && (
          <span onClick={closeFunc} className="cursor-pointer ml-3">
            <Icon name="close" backgroundColor="transparent" />
          </span>
        )}
      </span>
    </div>
  );
};

export const tagControls = {
  children: {
    propType: PropTypes.oneOfType([PropTypes.node, PropTypes.object])
      .isRequired,
    controlType: "text",
    description: "Tag Content (Text or otherwise)",
    defaultValue: "Example Tag",
  },
  color: {
    propType: PropTypes.string,
    controlType: "select",
    options: [
      "primary",
      "gray",
      "red",
      "yellow",
      "green",
      "blue",
      "teal",
      "purple",
      "pink",
    ],
    description: "Color variant of the tag",
    defaultValue: "primary",
  },
  rounded: {
    propType: PropTypes.string,
    controlType: "select",
    options: ["lg", "xl", "2xl"],
    description: "Rounding variant of the tag for the corners",
    defaultValue: "lg",
  },
  closeFunc: {
    propType: PropTypes.func,
    description: "Function to call when close button is clicked",
    disable: true,
  },
  block: {
    propType: PropTypes.bool,
    description: "If true, swaps from inline to full width",
    defaultValue: false,
  },
};

Tag.propTypes = AppUtils.getPropTypeFromControls(tagControls);

export default Tag;
